import { setRelatedResources } from '../../utils/functions.utils'

export const setResourceMaps = (resourceDemos: any) => {
  const resourceProducts = new Map()
  const resourceTopics = new Map()
  const resourceIndustry = new Map()
  const resourceDepartment = new Map()

  for (let i = 0; i < resourceDemos.length; i++) {
    if (resourceDemos[i].node) {
      let resourceDemo = resourceDemos[i].node
      let resourceDepartmentId
      let resourceIndustryId

      //group resourceDepartment && resourceIndustry content
      if (resourceDemo.metaInformation && resourceDemo.metaInformation.length) {
        let metaInformation = resourceDemo.metaInformation || []
        for (let j = 0; j < metaInformation.length; j++) {
          if (metaInformation[j].__typename) {
            if (metaInformation[j].__typename === 'ContentfulTopicResourceIndustry') {
              resourceIndustry.has(metaInformation[j].id)
                ? resourceIndustry.set(metaInformation[j].id, [
                    ...resourceIndustry.get(metaInformation[j].id),
                    resourceDemo,
                  ])
                : resourceIndustry.set(metaInformation[j].id, [resourceDemo])
              resourceIndustryId = metaInformation[j].id
            } else if (metaInformation[j].__typename === 'ContentfulTopicResourceDepartment') {
              resourceDepartment.has(metaInformation[j].id)
                ? resourceDepartment.set(metaInformation[j].id, [
                    ...resourceDepartment.get(metaInformation[j].id),
                    resourceDemo,
                  ])
                : resourceDepartment.set(metaInformation[j].id, [resourceDemo])
              resourceDepartmentId = metaInformation[j].id
            }
          }
        }
      }

      //group resourceTopics && resourceProducts content
      if (resourceDemo.topics && resourceDemo.topics.length) {
        let topics = resourceDemo.topics
        for (let j = 0; j < topics.length; j++) {
          if (topics[j].__typename === 'ContentfulTopicResourceTopic') {
            resourceTopics.has(topics[j].id)
              ? resourceTopics.set(topics[j].id, [
                  ...resourceTopics.get(topics[j].id),
                  resourceDemo,
                ])
              : resourceTopics.set(topics[j].id, [resourceDemo])
          } else if (topics[j].__typename === 'ContentfulTopicResourceProduct') {
            resourceProducts.has(topics[j].id)
              ? resourceProducts.set(topics[j].id, [
                  ...resourceProducts.get(topics[j].id),
                  resourceDemo,
                ])
              : resourceProducts.set(topics[j].id, [resourceDemo])
          }
        }
      }

      if (resourceDepartmentId) resourceDemo['resourceDepartmentId'] = resourceDepartmentId
      if (resourceIndustryId) resourceDemo['resourceIndustryId'] = resourceIndustryId
    }
  }

  return {
    resourceProducts,
    resourceTopics,
    resourceIndustry,
    resourceDepartment,
  }
}

export const getRelatedDemosForPost = (
  resourceDemoData: any,
  resourceProducts: any,
  resourceTopics: any,
  resourceIndustry: any,
  resourceDepartment: any
) => {
  if (!resourceDemoData) return []
  const seen = new Set()
  let topics = resourceDemoData.topics
  let relatedResourceDemo: any = []

  // retrieve up to three related success demos
  // on first loop, gather ONLY featured demos
  // check resource topics + resource products
  if (topics) {
    // resourceProducts
    for (let i = 0; i < topics.length; i++) {
      if (resourceProducts.has(topics[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedResourceDemo,
          relatedEntries: resourceProducts.get(topics[i].id),
          excludeId: resourceDemoData.contentful_id,
          seen,
          featured: true,
          resourceLocale: resourceDemoData.entryLocale,
        })
      }
      if (relatedResourceDemo.length === 3) break
    }
    // resourceTopics
    for (let i = 0; i < topics.length; i++) {
      if (resourceTopics.has(topics[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedResourceDemo,
          relatedEntries: resourceTopics.get(topics[i].id),
          excludeId: resourceDemoData.contentful_id,
          seen,
          featured: true,
          resourceLocale: resourceDemoData.entryLocale,
        })
      }
      if (relatedResourceDemo.length === 3) break
    }
  }

  // check resource department
  if (relatedResourceDemo.length < 3 && resourceDemoData.resourceDepartmentId) {
    if (resourceDepartment.has(resourceDemoData.resourceDepartmentId)) {
      setRelatedResources({
        relatedResourcesArray: relatedResourceDemo,
        relatedEntries: resourceDepartment.get(resourceDemoData.resourceDepartmentId),
        excludeId: resourceDemoData.contentful_id,
        seen,
        featured: true,
        resourceLocale: resourceDemoData.entryLocale,
      })
    }
  }

  // check resource industry
  if (relatedResourceDemo.length < 3 && resourceDemoData.resourceIndustryId) {
    if (resourceIndustry.has(resourceDemoData.resourceIndustryId)) {
      setRelatedResources({
        relatedResourcesArray: relatedResourceDemo,
        relatedEntries: resourceIndustry.get(resourceDemoData.resourceIndustryId),
        excludeId: resourceDemoData.contentful_id,
        seen,
        featured: true,
        resourceLocale: resourceDemoData.entryLocale,
      })
    }
  }

  // loop number 2 - non-featured demos included
  if (topics) {
    // resourceProducts
    for (let i = 0; i < topics.length; i++) {
      if (resourceProducts.has(topics[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedResourceDemo,
          relatedEntries: resourceProducts.get(topics[i].id),
          excludeId: resourceDemoData.contentful_id,
          seen,
          featured: false,
          resourceLocale: resourceDemoData.entryLocale,
        })
      }
      if (relatedResourceDemo.length === 3) break
    }
    // resourceTopics
    for (let i = 0; i < topics.length; i++) {
      if (resourceTopics.has(topics[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedResourceDemo,
          relatedEntries: resourceTopics.get(topics[i].id),
          excludeId: resourceDemoData.contentful_id,
          seen,
          featured: false,
          resourceLocale: resourceDemoData.entryLocale,
        })
      }
      if (relatedResourceDemo.length === 3) break
    }
  }

  // check resource department
  if (relatedResourceDemo.length < 3 && resourceDemoData.resourceDepartmentId) {
    if (resourceDepartment.has(resourceDemoData.resourceDepartmentId)) {
      setRelatedResources({
        relatedResourcesArray: relatedResourceDemo,
        relatedEntries: resourceDepartment.get(resourceDemoData.resourceDepartmentId),
        excludeId: resourceDemoData.contentful_id,
        seen,
        featured: false,
        resourceLocale: resourceDemoData.entryLocale,
      })
    }
  }

  // check resource industry
  if (relatedResourceDemo.length < 3 && resourceDemoData.resourceIndustryId) {
    if (resourceIndustry.has(resourceDemoData.resourceIndustryId)) {
      setRelatedResources({
        relatedResourcesArray: relatedResourceDemo,
        relatedEntries: resourceIndustry.get(resourceDemoData.resourceIndustryId),
        excludeId: resourceDemoData.contentful_id,
        seen,
        featured: false,
        resourceLocale: resourceDemoData.entryLocale,
      })
    }
  }

  return relatedResourceDemo
}
